import get from 'lodash/get';
import {
  GENDERS,
  GRADE_LEVEL,
} from '../../CollegeProfile/containers/OverviewMenu/CollegeEvents/eventsHelper';

export const CLICK_TRACKING_APPLICATION_NAVIANCE_COLLEGE_PROFILE_PAGE =
  'naviance_college_profile_page';

// Location
export const CLICK_TRACKING_LOCATION_EVENTS_LIST = 'college_profile_page_events_list';

// Type
export const CLICK_TRACKING_TYPE_COLLEGE_EVENT_SHOW_DETAILS =
  'college_event_show_details_clicked';
export const CLICK_TRACKING_TYPE_COLLEGE_EVENT_REGISTRATION_LINK =
  'college_event_registration_link_clicked';
export const CLICK_TRACKING_TYPE_COLLEGE_EVENT_PROFILE_LINK =
  'college_profile_link_clicked';
export const CLICK_TRACKING_TYPE_COLLEGE_EVENT_CARD_SHOWN =
  'college_event_card_shown';

// Format a single click tracking event
export const getSingleClickEvent = (event, userData) => {
  return {
    ...event,
    ...getClickTrackUser(userData),
  };
};

// Format click track event for the list of shown college vents
export const getBatchClickEvent = (events, userData) => {
  const payloads = events.map(event => {
    return {
      ...getClickTrackEventCommon(event),
    };
  });
  const batchEvent = {
    application: CLICK_TRACKING_APPLICATION_NAVIANCE_COLLEGE_PROFILE_PAGE,
    location: CLICK_TRACKING_LOCATION_EVENTS_LIST,
    type: CLICK_TRACKING_TYPE_COLLEGE_EVENT_CARD_SHOWN,
    ...getClickTrackUser(userData),
    ...(payloads && payloads.length > 0 && { payloads }),
  };
  return batchEvent;
};

// Format specific click track user data
export const getClickTrackUser = userData => {
  const {
    act,
    classYear,
    defaultGpa,
    gender = 'U',
    gradeLevel,
    highSchoolId,
    sat,
    address,
  } = userData;
  const { ceebCode } = userData;
  const state = get(address, 'state', get(userData.highSchool, 'state'));
  const zip = get(address, 'zip', get(userData.highSchool, 'zip'));
  return {
    ...(act && { act }),
    ...(ceebCode && { ceeb: ceebCode }),
    ...(classYear && { classYear: classYear.toString() }),
    ...(defaultGpa && { gpa: defaultGpa }),
    ...(gender && { gender: GENDERS[gender] }),
    ...(gradeLevel && { gradeLevel: GRADE_LEVEL[gradeLevel] }),
    ...(highSchoolId && { highSchoolId }),
    ...(sat && { sat }),
    ...(state && { state }),
    ...(zip && { zipCode: zip }),
  };
};

// Format specific click track event common data
export const getClickTrackEventCommon = ({
  id,
  recommendedAudienceProfile,
  college: { scid },
}) => {
  return {
    eventId: id,
    scid: scid || '',
    ...(recommendedAudienceProfile && { matchedFilterId: recommendedAudienceProfile.id }),
  };
};

// College event - sign up
export const getRegistrationLinkClicked = event => {
  return {
    application: CLICK_TRACKING_APPLICATION_NAVIANCE_COLLEGE_PROFILE_PAGE,
    location: CLICK_TRACKING_LOCATION_EVENTS_LIST,
    type: CLICK_TRACKING_TYPE_COLLEGE_EVENT_REGISTRATION_LINK,
    ...getClickTrackEventCommon(event),
  };
};

// College event - view more details
export const getCollegeEventDetailsClicked = event => {
  return {
    application: CLICK_TRACKING_APPLICATION_NAVIANCE_COLLEGE_PROFILE_PAGE,
    location: CLICK_TRACKING_LOCATION_EVENTS_LIST,
    type: CLICK_TRACKING_TYPE_COLLEGE_EVENT_SHOW_DETAILS,
    ...getClickTrackEventCommon(event),
  };
};

// College event - college profile name
export const getCollegeRecommendedEventProfileLinkClicked = event => {
  return {
    application: CLICK_TRACKING_APPLICATION_NAVIANCE_COLLEGE_PROFILE_PAGE,
    location: CLICK_TRACKING_LOCATION_EVENTS_LIST,
    type: CLICK_TRACKING_TYPE_COLLEGE_EVENT_PROFILE_LINK,
    ...getClickTrackEventCommon(event),
  };
};
